import {
  FETCH_PACKAGE_EVIDENCES_REQUEST,
  FETCH_PACKAGE_EVIDENCES_SUCCESS,
  FETCH_PACKAGE_EVIDENCES_FAILURE,
} from "../actions/types";

const initialState = {
  evidences: [],
  loading: false,
  error: null,
  message: "",
};

export default function packageEvidenceReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_PACKAGE_EVIDENCES_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        message: "",
      };

    case FETCH_PACKAGE_EVIDENCES_SUCCESS: {
      const data = action.payload?.data || [];

      return {
        ...state,
        loading: false,
        evidences: Array.isArray(data) ? data : [],
        message: "Package evidences fetched successfully",
      };
    }

    case FETCH_PACKAGE_EVIDENCES_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        evidences: [],
      };

    default:
      return state;
  }
}
